import * as React from 'react';
import { Link } from 'react-router-dom';
import actionTypes from '../../../../actions/ActionTypes';
import { LoadReaders, LoadReaderMaps } from '../../../../actions/ReadersActions';
import ReadersStore from '../../../../stores/ReadersStore';
import aiIcon from '../../../../images/TD AI Icon 2 Color.png';

class ReadersSidebar extends React.Component {
  //isList: Array<BPModel>;
  constructor(props) {
    super(props);

    this.state = {
      readerList: [],
      readerMaps: [],
      currentReader: undefined,
    };

    this.onReaderChange = this.onReaderChange.bind(this);
  }


  componentDidMount() {
    console.log('mount');
    ReadersStore.addChangeListener(this.onReaderChange);
    let list = ReadersStore.getReaders();
    let list2 = ReadersStore.getReaderMaps();
    if (list === undefined) {
      LoadReaders();
    } else {
      this.setState({ readerList: list });
    }
    console.log(list2);
    if(list2 === undefined || list2.length === 0) {
      LoadReaderMaps();
    } else {
      this.setState({ readerMaps: list2});
    }
  }

  componentWillUnmount() {
    ReadersStore.removeChangeListener(this.onReaderChange);
  }

  onReaderChange() {
    let lastChange = ReadersStore.getLastAction();
    if(lastChange === actionTypes.GetReaders)
    {
      console.log('getReaders');
      let list = ReadersStore.getReaders();
      this.setState({ readerList: list });
    }
    if(lastChange === actionTypes.ReaderMapLoad)
    {
      let list = ReadersStore.getReaderMaps();
      this.setState({ readerMaps: list });
      console.log(list);
    }

    //this.setState({ currentIs: IntakeStrategyStore.getCurrentIS() });
  }

  render() {
    let listOfReaders;
    if (this.state.readerList !== undefined) {
        listOfReaders = this.state.readerList.map((reader) => (
        <Link
          className='sidebar-link'
          to={'/Admin/Readers/' + reader.readerId}
          key={reader.readerId}
          //onClick={() => this.handleBPClick(bp)}
          style={{ cursor: 'Pointer' }}
        >
          <span>
            <i
              className='fa-solid fa-book-reader'
              style={{ color: '#6CB5D0' }}
            />
            {'   '}
            {reader.name}
          </span>
        </Link>
      ));
    } else {
        listOfReaders = <div />;
    }
    let listOfMaps;
    listOfMaps = this.state.readerMaps.map((map) => (
      <Link
        className='sidebar-link'
        to={'/Admin/ReaderMap/' + map.readerMapId}
        key={map.readerMapId}
        //onClick={() => this.handleBPClick(bp)}
        style={{ cursor: 'Pointer' }}
      >
         {map.readerName} <i
              className='fa-solid fa-arrow-right'
              style={{ color: '#6CB5D0' }}
            />{' '}{map.formTypeName}
      </Link>
    ));
    return (
      <div
        className='d-flex flex-column p-3 text-white bg-dark'
        style={{ height: '100%', width: '245px' }}
      >
        <Link
          to='/Admin/Readers'
          className='d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none'
        >
          <span className='fs-4'>

            <img src={aiIcon} className='aiMenuIcon2' alt='aiIcon' />{' '}
            {'   '}
            AI OCR
          </span>
        </Link>
        <hr />
        <label className='fs-4 display-6 mb-2'>Readers</label>
        {listOfReaders}
        <hr />

        <Link to='/Admin/Readers/new' className='sidebar-link'>
          New Reader
        </Link>
        <hr />
        <label className='fs-4 display-6 mb-2'>Maps</label>
        {listOfMaps}

        <hr />

        <Link to='/Admin/ReaderMap/new' className='sidebar-link'>
          New Form Type map
        </Link>
        <hr />
      </div>
    );
  }
}

export default ReadersSidebar;
